import { lazy } from "react";

const routes = [
  {
    path: "/settings/access-profiles",
    element: lazy(() => import("../../pages/Settings/AccessProfiles")),
  },
];

export default routes;
